import { makeStyles } from "@material-ui/core/styles";

const style = makeStyles((theme) => ({
  communityContainer: {
    background: "#FFFFFF",
    padding: "0px 32px 48px 32px",
    margin: "0px 0px 0px 0px",
    overflow: "hidden",
  },

  communityHeader: {
    display: "flex",
    alignItems: "center",
    marginBottom: "28px",
    justifyContent: "start",
  },

  communityLogo: {
    width: "120px",
    height: "90px",
    objectFit: "contain",
    flexShrink: 0,
  },

  communityHeading: {
    fontWeight: 700,
    fontSize: "32px",
    lineHeight: "38px",
    color: "#FF4E00",
    margin: "0px 0px 0px 24px",
  },

  communityDescription: {
    border: "1px solid #FFD1C1",
    borderRadius: "50px",
    padding: "18px 38px",
    marginBottom: "34px",
    textAlign: "start",
    boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.08)",
    overflow: "hidden",
  },

  descriptionText: {
    fontWeight: 500,
    fontSize: "28px",
    lineHeight: "34px",
    color: "#444444",
    margin: 0,
  },

  descriptionHighlight: {
    color: "#FF4E00",
    fontWeight: 700,
  },

  chooseCityText: {
    fontWeight: 700,
    fontSize: "22px",
    lineHeight: "28px",
    color: "#424242",
    margin: "0px 0px 24px 4px",
  },

  cityScrollContainer: {
    display: "flex",
    alignItems: "flex-start",
    overflowX: "auto",
    overflowY: "hidden",
    whiteSpace: "nowrap",
    padding: "0px 0px 8px 4px",

    msOverflowStyle: "none",
    scrollbarWidth: "none",

    "&::-webkit-scrollbar": {
      display: "none",
    },

    "&::-moz-scrollbars": {
      display: "none",
    },
  },

  cityCard: {
    width: "140px",
    minWidth: "140px",
    flexShrink: 0,
    marginRight: "54px",
    textAlign: "center",
    position: "relative",
    cursor: "pointer",
  },

  cityImageWrapper: {
    width: "132px",
    height: "132px",
    margin: "0 auto",
    position: "relative",
    borderRadius: "50%",
    overflow: "visible",
  },

  cityImage: {
    width: "132px",
    height: "132px",
    objectFit: "cover",
    borderRadius: "50%",
    display: "block",
    border: "3px solid #007E33",
  },

  whatsappIcon: {
    position: "absolute",
    width: "32px",
    height: "32px",
    right: "-2px",
    top: "-2px",
    zIndex: 2,
  },

  blankCityImage: {
    width: "132px",
    height: "132px",
    borderRadius: "50%",
    border: "3px solid #007E33",
    background: "#FFFFFF",
  },

  cityName: {
    fontWeight: 600,
    fontSize: "15px",
    lineHeight: "20px",
    color: "#424242",
    marginTop: "16px",
    whiteSpace: "nowrap",
  },

  cityLink: {
    textDecoration: "none",
    color: "inherit",
    display: "block",
  },

  "@media (min-width: 651px) and (max-width: 850px)": {
    communityContainer: {
      padding: "0px 40px 0px 40px",
    },

    communityHeading: {
      fontSize: "26px",
      lineHeight: "32px",
      marginLeft: "16px",
    },

    communityDescription: {
      padding: "16px 24px",
      textAlign: "center",
    },

    descriptionText: {
      fontSize: "22px",
      lineHeight: "28px",
    },

    cityCard: {
      marginRight: "40px",
    },
  },

  "@media (min-width: 551px) and (max-width: 650px)": {
    communityContainer: {
      padding: "0px 24px 0px 24px",
    },

    communityLogo: {
      width: "100px",
      height: "76px",
    },

    communityHeading: {
      fontSize: "24px",
      lineHeight: "30px",
      marginLeft: "12px",
    },

    communityDescription: {
      padding: "14px 20px",
      marginBottom: "28px",
      textAlign: "center",
    },

    descriptionText: {
      fontSize: "18px",
      lineHeight: "24px",
    },

    chooseCityText: {
      fontSize: "20px",
      lineHeight: "26px",
    },

    cityCard: {
      width: "120px",
      minWidth: "120px",
      marginRight: "32px",
    },

    cityImageWrapper: {
      width: "112px",
      height: "112px",
    },

    cityImage: {
      width: "112px",
      height: "112px",
    },

    blankCityImage: {
      width: "112px",
      height: "112px",
    },

    whatsappIcon: {
      width: "28px",
      height: "28px",
    },

    cityName: {
      fontSize: "14px",
      marginTop: "12px",
    },
  },

  "@media (max-width: 550px)": {
    communityContainer: {
      padding: "0px 16px 0px 16px",
      margin: "0px 0px 32px 0px",
    },

    communityHeader: {
      marginBottom: "8px",
      justifyContent: "center",
    },

    communityLogo: {
      width: "82px",
      height: "64px",
    },

    communityHeading: {
      fontSize: "16px",
      lineHeight: "25px",
      marginLeft: "0px",
    },

    communityDescription: {
      borderRadius: "28px",
      padding: "12px 16px",
      marginBottom: "24px",
      textAlign: "center",
      whiteSpace: "normal",
    },

    descriptionText: {
      fontSize: "12px",
      lineHeight: "21px",
    },

    chooseCityText: {
      fontSize: "16px",
      lineHeight: "20px",
      margin: "0px 0px 18px 2px",
    },

    cityScrollContainer: {
      paddingLeft: "2px",
      paddingRight: "0px",
      paddingBottom: "4px",
    },

    cityCard: {
      width: "88px",
      minWidth: "88px",
      marginRight: "30px",
    },

    cityImageWrapper: {
      width: "80px",
      height: "80px",
    },

    cityImage: {
      width: "80px",
      height: "80px",
    },

    blankCityImage: {
      width: "80px",
      height: "80px",
    },

    whatsappIcon: {
      width: "25px",
      height: "25px",
      right: "-2px",
      top: "-2px",
    },

    cityName: {
      fontSize: "12px",
      lineHeight: "16px",
      marginTop: "10px",
    },
  },
}));

export default style;
